// Package Imports
import { toJS } from "mobx"

// Project Imports
import AuthStore from "modules/login/store/AuthStore"
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import fetchNeedMaster from "utils/fetchNeedMasterData"
import axios from "utils/axios"
import * as APITypes from "constants/API"
import incomeTypeEnum from "constants/incomeTypeEnum"
import FamilyMemberModalTypeEnum from "constants/familyMemberModalTypeEnum";
import StorageKeys from "constants/StorageKeys";
import NeedTypeEnum from "constants/NeedTypeEnum"
import generateFamilyProductId from "../../../utils/change-la/generateChangeLAFamilyProductId";
import generateAddAssuredFamilyProductId from "modules/optimization/utils/add-assured/generateAddAssuredFamilyProductId"
import generateAddNeedFamilyProductId from "modules/optimization/utils/add-need/generateAddNeedFamilyProductId"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../../constants/Constants"
import moment from "moment"

const submitDataToTheServer = async (formController, hideRetirementPopUpModal, buttonType) => {


  // !calling the backend api Fetch BI Data based on provided recommendation
  const formFieldValues = formController.get()
  const targetAmountMidValue = formFieldValues.target_amount_dropdown.value.mid_value
  RetirementBiDataApiCall(targetAmountMidValue, hideRetirementPopUpModal, formFieldValues, buttonType)


}

const isValidFunction = async (formController) => {
  const validValue = formController
    .validate({ showErrors: true })
    .then(({ isValid }) => {
      if (!isValid) {
        console.log("Form errors are ", formController.errors())
      }
      return isValid
    })

  return validValue
}


export const onRecommend = async (formController, hideRetirementPopUpModal) => {
  const valid = await isValidFunction(formController)

  if (valid) {
    OptimizationStore.isCalculatorUsed = false
    submitDataToTheServer(formController, hideRetirementPopUpModal, "recommend")
  }
}

export const onSet = async (formController, hideRetirementPopUpModal) => {
  const valid = await isValidFunction(formController)

  if (valid) {
    OptimizationStore.isCalculatorUsed = false
    submitDataToTheServer(formController, hideRetirementPopUpModal)
  }
}

export const onLaunch = async (formController, openRetirementCalculator, getFamilyMemberType) => {
  const valid = await isValidFunction(formController)
  if (valid) {
    openRetirementCalculator()
    getFamilyMemberType()
  }
}

export const RetirementBiDataApiCall = async (targetAmountValue, hideModal = OptimizationStore.resetSelectedNeedAndMemberId, formFieldValues, buttonType) => {

  let masterData = await fetchNeedMaster()

  if (masterData.length <= 0) return

  let selectedNeedId = masterData.find((singleNeed) => singleNeed.unique_name === OptimizationStore.selectedNeed).id

  let recommendationReqDataToBeSubmitted = {
    "user_journey": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
    "family": OptimizationStore.selectedFamilyMemberId,
    "need": selectedNeedId,
    "target_amount_value": OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
    "payout_mode": buttonType === "recommend" ? "RECOMMENDED_INCOME" : incomeTypeEnum.INCOME.toLowerCase(),
    "target_amount": OptimizationStore.isCalculatorUsed || buttonType === "recommend" ? null : formFieldValues.target_amount_dropdown.value.id,
    "is_selected": true,
    "secondary_la_id": OptimizationStore.isSecondaryIdseleted ? OptimizationStore.selectedFamilyMemberId : ""

  }


  function isAdult(member) {

    const dob = moment(member.dob);
    const today = moment();
    const age = today.diff(dob, 'years');
    let memberType = OptimizationStore.isPrimaryLASelectedForAddAsured ? OptimizationStore.isPrimaryLASelectedForAddAsured : OptimizationStore.firstNewlyAddedItem
    return age > 18 && member.family_member_type === memberType
  }

  switch (OptimizationStore.familyMemberModalType) {
    case FamilyMemberModalTypeEnum.CHANGE_LA:
    case FamilyMemberModalTypeEnum.CHANGE_SECONDARY_LA:
    case FamilyMemberModalTypeEnum.ADD_SECONDARY_LA:
      generateFamilyProductId(recommendationReqDataToBeSubmitted, hideModal, NeedTypeEnum.SAVE_FOR_RETIREMENT)
      return

    case FamilyMemberModalTypeEnum.ADD_INSURED:

      console.log(OptimizationStore.fetchFamilyMemberListForLifeAssured(), OptimizationStore.isPrimaryLASelectedForAddAsured, "fetchFamilyMemberListForLifeAssured");
      //const primaryId = OptimizationStore.fetchFamilyMemberListForLifeAssured().filter((item) => moment().diff(moment(item.dob), 'years') && item.is_member_selected == true)?.id


      let filteredMembers = OptimizationStore.fetchFamilyMemberListForLifeAssured().filter(isAdult);

      const selectedProductForInsured = formFieldValues.products_list.value?.package_id
      const selectedProductRiskForInsured = formFieldValues.products_list.value?.risk

      let idOfFirstRow = filteredMembers[0]?.id;
      if (!idOfFirstRow) {
        var arr = OptimizationStore.fetchFamilyMemberListForLifeAssured();
        console.log("arr", arr)
        filteredMembers1 = arr.filter((item) => item.family_member_type === 'SELF')[0]
        idOfFirstRow = filteredMembers1?.id
        console.log(idOfFirstRow, "idOfFirstRow");
      }

      console.log(idOfFirstRow, "idFirstRow")

      const addInsuredObj = {
        family_member_id: idOfFirstRow,
        user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        need_id: selectedNeedId,
        is_selected: true,
        is_calculator_used: false,
        monthly_income: filteredMembers?.monthly_income,
        dob: filteredMembers.dob,
        target_amount_id: OptimizationStore.isCalculatorUsed || buttonType === "recommend" ? null : formFieldValues.target_amount_dropdown.value.id,
        target_amount_value: OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        is_calculator_used: OptimizationStore.isCalculatorUsed,
        payout_mode: buttonType === "recommend" ? "RECOMMENDED_INCOME" : incomeTypeEnum.INCOME.toLowerCase(),
        dob: filteredMembers?.dob,
        monthly_income: filteredMembers?.monthly_income,
        secondary_la: OptimizationStore.isSecondaryLASelectdForAddAssured,
        "selected_product_package_id": selectedProductForInsured ? selectedProductForInsured : null,
        "selected_product_risk": selectedProductRiskForInsured ? selectedProductRiskForInsured : null

      };
      OptimizationStore.setSecondaryLASelectdForAddAssured(null)
      OptimizationStore.setPrimaryLASelectedForAddAsured(null)
      generateAddAssuredFamilyProductId(addInsuredObj, hideModal, NeedTypeEnum.SAVE_FOR_RETIREMENT)
      return;

    case FamilyMemberModalTypeEnum.ADD_NEED:

      console.log(OptimizationStore.fetchFamilyMemberListForLifeAssured(), OptimizationStore.isPrimaryLASelectedForAddAsured, "fetchFamilyMemberListForLifeAssured");
      //const primaryId = OptimizationStore.fetchFamilyMemberListForLifeAssured().filter((item) => moment().diff(moment(item.dob), 'years') && item.is_member_selected == true)?.id


      let filteredMembers1 = OptimizationStore.fetchFamilyMemberListForLifeAssured().filter(isAdult);


      let idOfFirstRow1 = filteredMembers1[0]?.id;
      if (!idOfFirstRow1) {
        var arr = OptimizationStore.fetchFamilyMemberListForLifeAssured();
        console.log("arr", arr)
        filteredMembers1 = arr.filter((item) => item.family_member_type === 'SELF')[0]
        idOfFirstRow = filteredMembers1?.id

        console.log(idOfFirstRow1, "idOfFirstRow1");
      }

      console.log(idOfFirstRow1, "idFirstRow1");


      let journeyData = toJS(AuthStore.journeyData)
      let memberData = journeyData.family_details_list.find((member) => member.id === OptimizationStore.selectedFamilyMemberId)
      const selectedProductForNeed = formFieldValues.products_list.value?.package_id
      const selectedProductRiskForNeed = formFieldValues.products_list.value?.risk

      let familyProductIdRequest = {
        "family_member_id": idOfFirstRow1,
        "user_journey_id": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        "need_id": selectedNeedId,
        "is_selected": true,
        "is_removed": false,
        "is_calculator_used": OptimizationStore.isCalculatorUsed,
        "dob": filteredMembers1?.dob,
        "target_amount_id": OptimizationStore.isCalculatorUsed || buttonType === "recommend" ? null : formFieldValues.target_amount_dropdown.value?.id,
        "target_amount_value": OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        "payout_mode": buttonType === "recommend" ? "RECOMMENDED_INCOME" : incomeTypeEnum.INCOME.toLowerCase(),
        "secondary_la": OptimizationStore.isSecondaryLASelectdForAddAssured,
        "selected_product_package_id": selectedProductForNeed ? selectedProductForNeed : null,
        "selected_product_risk": selectedProductRiskForNeed ? selectedProductRiskForNeed : null

      }
      OptimizationStore.setSecondaryLASelectdForAddAssured(null)
      OptimizationStore.setPrimaryLASelectedForAddAsured(null)
      generateAddNeedFamilyProductId(familyProductIdRequest, hideModal, NeedTypeEnum.SAVE_FOR_RETIREMENT)
      return
  }
  let responseDataArray = []

  let biResponse = await axios.post(
    APITypes.FETCH_BI_DATA_BASED_ON_PROVIDED_RECOMMENDATION,
    recommendationReqDataToBeSubmitted
  )

  responseDataArray.push(biResponse.data)

  if (hideModal !== undefined) {
    hideModal()
  }

  OptimizationStore.addNeed({
    "data": responseDataArray
  })

}


export const prefillProductsList = async () => {
  let agentID = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)
  let isPosp =  localStorage.getItem(StorageKeys.IS_POSP)
  const response = await axios.get(`${APITypes.GET_PRODUCTS_LIST}?agent_id=${agentID}&is_posp=${isPosp}`)
  return response.data;
}